import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../../components/Breadcrumb";

export const Kit = () => {
    document.title = "Bağlamalar";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters" },
        { name: "Bağlamalar", value: "/products/parameters/kit", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Bağlamalar</h2>
                    <p>
                        Məhsulun müxtəlif say və ölçü vahidi ilə, <b>bağlama</b> şəklində <Link to={""}>alış</Link>, <Link to={""}>satış</Link> və s. icra etmək
                        üçün bağlama funksiyası nəzərdə tutulub. Həmçinin bağlamaya alış və satış qiyməti təyin etmək mümkündür. <br />
                        <b>Qeyd</b>: Məhsula bir neçə bağlama təyin etmək olur
                    </p>
                    <img src="/images/products/parameters/kit.gif" alt="Bağlamalar" />
                </article>
            </div>
        </div>
    );
};
